import { initBraze as initBrazeSdk } from '@lili/lili-frontend-common/util';
import { reportError } from '@/services/bugsnag.ts';

/**
 * Initializes Braze for the accountant portal.
 *
 * Accountants live in the dedicated Accountants Braze workspace, so the portal uses the
 * accountant app-group key (`VITE_BRAZE_API_KEY`) and identifies each session by the
 * accountant's authorized user id (the `accountantExternalId`).
 */
export const initBraze = async (accountantExternalId: string) => {
  try {
    await initBrazeSdk({
      appKey: import.meta.env.VITE_BRAZE_API_KEY,
      baseUrl: import.meta.env.VITE_BRAZE_BASE_URL,
      enableLogging: import.meta.env.VITE_BRAZE_LOGGING_ENABLED === 'true',
      userId: accountantExternalId,
    });
  } catch (error) {
    // Braze is non-critical — never let it break the portal.
    reportError({ error: error instanceof Error ? error : new Error(String(error)) });
  }
};
